// This is just an example,
// so you can safely delete all default props below

export default {
    signin_title: 'Sign In',
    signin_desc: '',
    signin: 'Sign In',
    email: 'Email',
    password: 'Password',
    remember_me: 'Remember Me',
    signup: 'Sign Up',
    stay_signed_in: 'Stay signed in',
    forget_password: 'Forget Password?',
    error_email: 'Email is not valid',
    error_password: 'Password must be provided',
    error_sign_in: 'The email and password combination is not correct'
}
